class AlertSerializer {
  static deSerialize(data) {
    return {
      id: data.AWeId,
      lines: (data.AWeMensaje || '').split('\r\n'),
    };
  }
}

export { AlertSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/AlertSerializer.js